import { Spacer } from '@lokalise/louis';

import useSelector from '@app/hooks/useSelector';

import { getLanguageListBaseLanguage, getLanguageListLanguages } from '../../reducers/downloadData/selectors';
import type { LanguageId } from '../../types';
import ExportAccordion from '../ExportAccordion';
import List, { type LanguageListItem } from './LanguageList';

export type { LanguageListItem };

type Value = {
    languages: readonly string[];
    customIso: Record<LanguageId, string>;
};

interface LanguagesProps {
    value: Value;
    projectId: string;
    onChange: (value: Value) => void;
}

const Languages = ({ value, projectId, onChange }: LanguagesProps) => {
    const baseLanguage = useSelector(getLanguageListBaseLanguage);
    const languages = useSelector(getLanguageListLanguages);

    return (
        <ExportAccordion heading="Languages" projectId={projectId} name="languages-list" initiallyExpanded>
            <section aria-label="Languages list">
                <Spacer top={3}>
                    <List value={value} baseLanguage={baseLanguage} languages={languages} onChange={onChange} />
                </Spacer>
            </section>
        </ExportAccordion>
    );
};

export default Languages;
